// extracted by mini-css-extract-plugin
export default {"gift-icon":"RfFcl","giftIcon":"RfFcl","wiggle":"_2sxbO"};